import CustomIcon from 'components/customIcon';
import styled from '@emotion/styled';
import { MenuItem, Select } from '@mui/material';
import { ReactComponent as ArrowIcon } from 'assets/img/arrow.svg';
import { useContext } from 'react';
import { LanguageContext } from 'components/language';

const typesFilter = [
    {
        name: 'FOR_TODAY',
        value: 'FOR_TODAY',
    },
    {
        name: 'FOR_YESTERDAY',
        value: 'FOR_YESTERDAY',
    },
    {
        name: 'FOR_CURRENT_MONTH',
        value: 'FOR_CURRENT_MONTH',
    },
    {
        name: 'FOR_LAST_MONTH',
        value: 'FOR_LAST_MONTH',
    },
    {
        name: 'SELECT_DATES',
        value: 'SELECT_DATES',
    },
];

const ReportsHeader = () => {
    const { t } = useContext(LanguageContext);

    return (
        <Styled>
            <div className="left-side">
                <h2 className="title">
                    Звіти <span className="date">(13-20 Грудня)</span>
                </h2>
            </div>
            <div className="right-side">
                <Select
                    className="hotel-select"
                    IconComponent={ArrowIcon}
                    sx={{ '& fieldset': { boxShadow: 'none !important' } }}
                    MenuProps={{
                        PopoverClasses: {
                            paper: 'hotels_select_body beauty_scrollbar',
                        },
                    }}
                    label="Всі категорії"
                >
                    {typesFilter.map(({ name, value }) => (
                        <MenuItem value={value}>{t(name)}</MenuItem>
                    ))}
                </Select>
                <Select
                    className="hotel-select"
                    IconComponent={ArrowIcon}
                    sx={{ '& fieldset': { boxShadow: 'none !important' } }}
                    MenuProps={{
                        PopoverClasses: {
                            paper: 'hotels_select_body beauty_scrollbar',
                        },
                    }}
                    label="Всі категорії"
                >
                    <MenuItem value={'fds'}>Category name</MenuItem>
                    <MenuItem value={'fds'}>Category name</MenuItem>
                    <MenuItem value={'fds'}>Category name</MenuItem>
                </Select>
                <div className="icon">
                    <CustomIcon icon="printer" />
                </div>
                <div className="icon">
                    <CustomIcon icon="more" />
                </div>
            </div>
        </Styled>
    );
};

const Styled = styled.div`
    height: 64px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: white;
    padding-inline: 40px;

    .left-side,
    .right-side {
        display: flex;
        gap: 10px;
        align-items: center;

        .icon {
            width: 24px;
            height: 24px;
            cursor: pointer;
        }
    }

    .left-side {
        .title {
            font-weight: 600;
            font-size: 20px;
            .date {
                font-weight: 400;
                font-size: 15px;
                line-height: 100%;
            }
        }
    }

    .right-side {
        .icon {
            width: 30px;
        }
        .hotel-select {
            width: 180px;
            min-width: 162px;
            height: 32px;
            background: #f0f2f8;
            padding: 6px 12px;

            .MuiSelect-select {
                padding: 0;
                font-weight: 500;
                font-family: Montserrat;
                font-size: 14px;
                line-height: 20px;
                color: #2d2d4b;
                max-width: 90%;
            }
            .MuiSelect-icon {
                right: 0 !important;
            }
        }
    }

    @media only screen and (max-width: 767px) {
        padding-inline: 20px;
        .right-side {
            button {
                padding: 0 12px;
            }

            .hotel-select {
                display: none;
            }
        }
    }
`;

export default ReportsHeader;
